import React, { useCallback } from 'react';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
const CustomOptionButton = ({ icon: iconSrc, onClick, text }) => {
    const icon = useCallback(props => (React.createElement("img", Object.assign({ src: iconSrc }, props))), [iconSrc]);
    return (React.createElement(ContextMenuItem, { accessibilityLabel: text, icon: icon, onClick: onClick, text: text }));
};
export default CustomOptionButton;
